<template>
    <div>
         <modal :show.sync="addObligation" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar obligación</h6>
                <form data-vv-scope="addFinancialObligation">
                <div class="form-group">
                    <label>Tipo de crédito *</label>
                    <fg-input  name="tipo de crédito"
                                v-model="obligationType"
                                v-validate="modelValidations.obligationType"
                                :error="getError('addFinancialObligation.tipo de crédito')">
                        <el-select 
                                name="tipo de crédito"
                                class="select-warning"
                                size="large"
                                placeholder="Seleccione..."
                                v-model="obligationType">
                                <el-option v-for="obligationType in $store.getters.getFinancialObligationTypes" :key="obligationType.id"
                                        class="select-warning"
                                        :value="obligationType.name"
                                        :label="obligationType.name">
                                </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Entidad *</label>
                    <fg-input   tabindex="0"
                                type="text"
                                name="Entidad"
                                placeholder="Entidad"
                                autocomplete="off"
                                v-validate="modelValidations.entity_name"
                                :error="getError('addFinancialObligation.Entidad')"
                                v-model="obligationEntity">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Rol *</label>
                    <fg-input   name="rol"
                                v-validate="modelValidations.obligationRole"
                                :error="getError('addFinancialObligation.rol')"
                                v-model="obligationRole">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationRole">
                            <el-option 
                                    class="select-warning"
                                    value="Titular"
                                    label="Titular">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Codeudor cónyuge"
                                    label="Codeudor cónyuge">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Tipo de cuenta</label>
                    <fg-input   name="tipo de cuenta"
                                v-validate="modelValidations.obligationAccountType"
                                :error="getError('tipo de cuenta')"
                                v-model="obligationAccountType">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationAccountType">
                            <el-option v-for="accountType in $store.getters.getAccountTypes" :key="accountType.code"
                                    class="select-warning"
                                    :value="accountType.code"
                                     :label="`(${accountType.code})-${accountType.name}`">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Monto crédito *</label>
                    <vue-numeric  :max=999999999 tabindex="1" currency="$" autocomplete="off" name="monto crédito" v-validate="modelValidations.obligationAmountCredit" :error="getError('addFinancialObligation.monto crédito')" separator="." class="form-control" v-model="obligationAmountCredit"></vue-numeric>
                    <span v-show="errors.has('addFinancialObligation.monto crédito')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('addFinancialObligation.monto crédito') }}
                    </span>
                </div>
                <div class="form-group">
                    <label>Saldo / Central de riesgo *</label>
                    <vue-numeric  :max=999999999 tabindex="1" currency="$" autocomplete="off" name="saldo" v-validate="modelValidations.obligationResidue" :error="getError('addFinancialObligation.saldo')" separator="." class="form-control" v-model="obligationResidue"></vue-numeric>
                    <span v-show="errors.has('addFinancialObligation.saldo')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('addFinancialObligation.saldo') }}
                    </span>
                </div>
                <div v-if="parseInt(obligationAmountCredit) < parseInt(obligationResidue)" class="alert alert-danger mt-2">
                    <span>El monto no puede ser menor al saldo</span>
                </div>
                <div v-if="obligationAccountType == 'TDC'" class="form-group">
                    <label>Saldo contingente TDC *</label>
                    <vue-numeric  disabled :max=999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="obligationContingentResidueComputed"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Cuota / Central de riesgo *</label>
                    <vue-numeric  :max=999999999 tabindex="1" currency="$" autocomplete="off" name="valor cuota" v-validate="modelValidations.obligationQuota" :error="getError('addFinancialObligation.valor cuota')" separator="." class="form-control" v-model="obligationQuota"></vue-numeric>
                    <span v-show="errors.has('addFinancialObligation.valor cuota')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('addFinancialObligation.valor cuota') }}
                    </span>
                </div>
                <div v-if="obligationAccountType == 'TDC'" class="form-group">
                    <label>Cuota contigente TDC *</label>
                    <vue-numeric  disabled :max=999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="obligationContingentQuotaComputed"></vue-numeric>
                </div>
                <div v-if="obligationAccountType == 'TDC'" class="form-group">
                    <label>Saldo balance *</label>
                    <vue-numeric  disabled :max=999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="obligationResidueCreditFlowComputed"></vue-numeric>
                </div>
                <div v-if="obligationAccountType == 'TDC'" class="form-group">
                    <label>Cuota flujo de caja *</label>
                    <vue-numeric  :max=999999999 tabindex="1" currency="$" autocomplete="off" name="cuota flujo de caja" v-validate="obligationAccountType === 'TDC' ? modelValidations.obligationQuotaCreditFlowRequired : modelValidations.obligationQuotaCreditFlow" :error="getError('addFinancialObligation.cuota flujo de caja')" separator="." class="form-control" v-model="obligationQuotaCreditFlow" @change="changeCreditFlow()"></vue-numeric>
                    <span v-show="errors.has('addFinancialObligation.cuota flujo de caja')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('addFinancialObligation.cuota flujo de caja') }}
                    </span>
                    <p-button v-show="manualQuotaOverride != ''" type="info" @click="resetObligationQuotaCreditFlow()">Recalcular Cuota</p-button>
                </div>
                <div class="form-group">
                    <label>Plazo *</label>
                    <fg-input   tabindex="0"
                                type="number"
                                name="plazo"
                                placeholder="plazo"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_term"
                                :error="getError('addFinancialObligation.plazo')"
                                v-model="obligationTerm">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label># de cuotas pendientes *</label>
                    <fg-input   tabindex="0"
                                type="number"
                                name="# de cuotas pendientes"
                                placeholder="# de cuotas pendientes"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_pending"
                                :error="getError('addFinancialObligation.# de cuotas pendientes')"
                                v-model="obligationPendingQuota">
                    </fg-input>
                </div>
                <div v-if="parseInt(obligationPendingQuota) > parseInt(obligationTerm)" class="alert alert-danger mt-2">
                    <span>Las cuotas pendientes no pueden ser mayores al plazo</span>
                </div>
                <div class="form-group">
                    <label>% Cuotas *</label>
                    <fg-input   disabled
                                tabindex="0"
                                type="number"
                                name="porcentaje de cuotas"
                                placeholder="porcentaje de cuotas"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('porcentaje de cuotas')"
                                v-model="obligationPendingPercentComputed">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.periodicity"
                                :error="getError('addFinancialObligation.periodicidad')"
                                v-model="obligationPeriodicity">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationPeriodicity">
                            <el-option 
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Bimensual"
                                    label="Bimensual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Trimestral"
                                    label="Trimestral">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Semestral"
                                    label="Semestral">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Anual"
                                    label="Anual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Otra periodicidad"
                                    label="Otra periodicidad">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Mes inicio periodicidad *</label>
                    <el-date-picker
                        v-validate="'required'"
                        data-vv-name="mes inicio periodicidad"
                        name="mes inicio periodicidad"
                        :error="getError('addFinancialObligation.mes inicio periodicidad')"
                        v-model="obligationDate"
                        type="month"
                        placeholder="Seleccione mes inicio periodicidad">
                    </el-date-picker>
                    <span v-show="errors.has('addFinancialObligation.mes inicio periodicidad')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('addFinancialObligation.mes inicio periodicidad') }}
                    </span>
                </div>
                <div class="form-group">
                    <label>Destino del crédito *</label>
                    <fg-input   name="destino del crédito"
                                v-validate="modelValidations.obligationCreditDestiny"
                                :error="getError('addFinancialObligation.destino del crédito')"
                                v-model="obligationCreditDestiny">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationCreditDestiny">
                            <el-option 
                                    class="select-warning"
                                    value="Capital de trabajo"
                                    label="Capital de trabajo">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Activo fijo"
                                    label="Activo fijo">
                            </el-option>
                            <el-option 
                                    v-show="obligationAccountType == 'TDC'"
                                    class="select-warning"
                                    value="Libre inversión"
                                    label="Libre inversión">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="obligationPeriodicity == 'Otra periodicidad'" class="form-group">
                    <div class="alert alert-info mt-2">
                        <span>Diligencia a continuación los meses para Otra periodicidad</span>
                    </div>
                    <div v-for="(month, index) in obligationMonths" :key="index" class="form-group">
                        <label>{{ month.name }}</label>
                        <vue-numeric  :max=999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="month.value"></vue-numeric>
                    </div>
                </div>
                </form>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelAddObligation()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="addObligationToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editObligation" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar obligación</h6>
            <form data-vv-scope="editFinancialObligation">
                <div class="form-group">
                    <label>Tipo de crédito *</label>
                    <fg-input  name="tipo de crédito"
                                v-model="obligationType"
                                v-validate="modelValidations.obligationType"
                                :error="getError('editFinancialObligation.tipo de crédito')">
                        <el-select 
                                name="tipo de crédito"
                                class="select-warning"
                                size="large"
                                placeholder="Seleccione..."
                                v-model="obligationType">
                                <el-option v-for="obligationType in $store.getters.getFinancialObligationTypes" :key="obligationType.id"
                                        class="select-warning"
                                        :value="obligationType.name"
                                        :label="obligationType.name">
                                </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Entidad *</label>
                    <fg-input   tabindex="0"
                                type="text"
                                name="Entidad"
                                placeholder="Entidad"
                                autocomplete="off"
                                v-validate="modelValidations.entity_name"
                                :error="getError('editFinancialObligation.Entidad')"
                                v-model="obligationEntity">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Rol *</label>
                    <fg-input   name="rol"
                                v-validate="modelValidations.obligationRole"
                                :error="getError('editFinancialObligation.rol')"
                                v-model="obligationRole">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationRole">
                            <el-option 
                                    class="select-warning"
                                    value="Titular"
                                    label="Titular">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Codeudor cónyuge"
                                    label="Codeudor cónyuge">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Tipo de cuenta</label>
                    <fg-input   name="tipo de cuenta"
                                v-validate="modelValidations.obligationAccountType"
                                :error="getError('tipo de cuenta')"
                                v-model="obligationAccountType">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationAccountType">
                            <el-option v-for="accountType in $store.getters.getAccountTypes" :key="accountType.code"
                                    class="select-warning"
                                    :value="accountType.code"
                                     :label="`(${accountType.code})-${accountType.name}`">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Monto crédito *</label>
                    <vue-numeric  :max=999999999 tabindex="1" currency="$" autocomplete="off" name="monto crédito" v-validate="modelValidations.obligationAmountCredit" :error="getError('editFinancialObligation.monto crédito')" separator="." class="form-control" v-model="obligationAmountCredit"></vue-numeric>
                    <span v-show="errors.has('editFinancialObligation.monto crédito')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('editFinancialObligation.monto crédito') }}
                    </span>
                </div>
                <div class="form-group">
                    <label>Saldo / Central de riesgo *</label>
                    <vue-numeric  :max=999999999 tabindex="1" currency="$" autocomplete="off" name="saldo" v-validate="modelValidations.obligationResidue" :error="getError('editFinancialObligation.saldo')" separator="." class="form-control" v-model="obligationResidue"></vue-numeric>
                    <span v-show="errors.has('editFinancialObligation.saldo')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('editFinancialObligation.saldo') }}
                    </span>
                </div>
                <div v-if="parseInt(obligationAmountCredit) < parseInt(obligationResidue)" class="alert alert-danger mt-2">
                    <span>El monto no puede ser menor al saldo</span>
                </div>
                <div v-if="obligationAccountType == 'TDC'" class="form-group">
                    <label>Saldo contingente TDC *</label>
                    <vue-numeric  disabled :max=999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="obligationContingentResidueComputed"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Cuota / Central de riesgo *</label>
                    <vue-numeric  :max=999999999 tabindex="1" currency="$" autocomplete="off" name="valor cuota" v-validate="modelValidations.obligationQuota" :error="getError('editFinancialObligation.valor cuota')" separator="." class="form-control" v-model="obligationQuota"></vue-numeric>
                    <span v-show="errors.has('editFinancialObligation.valor cuota')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('editFinancialObligation.valor cuota') }}
                    </span>
                </div>
                <div v-if="obligationAccountType == 'TDC'" class="form-group">
                    <label>Cuota contigente TDC *</label>
                    <vue-numeric  disabled :max=999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="obligationContingentQuotaComputed"></vue-numeric>
                </div>
                <div v-if="obligationAccountType == 'TDC'" class="form-group">
                    <label>Saldo balance *</label>
                    <vue-numeric  disabled :max=999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="obligationResidueCreditFlowComputed"></vue-numeric>
                </div>
                <div v-if="obligationAccountType == 'TDC'" class="form-group">
                    <label>Cuota flujo de caja *</label>
                    <vue-numeric  :max=999999999 tabindex="1" currency="$" autocomplete="off" name="cuota flujo de caja" v-validate="obligationAccountType === 'TDC' ? modelValidations.obligationQuotaCreditFlowRequired : modelValidations.obligationQuotaCreditFlow" :error="getError('editFinancialObligation.cuota flujo de caja')" separator="." class="form-control" v-model="obligationQuotaCreditFlow" @change="changeCreditFlow()"></vue-numeric>
                    <span v-show="errors.has('editFinancialObligation.cuota flujo de caja')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('editFinancialObligation.cuota flujo de caja') }}
                    </span>
                    <p-button v-show="manualQuotaOverride != ''" type="info" @click="resetObligationQuotaCreditFlow()">Recalcular Cuota</p-button>
                </div>
                <div class="form-group">
                    <label>Plazo *</label>
                    <fg-input   tabindex="0"
                                type="number"
                                name="plazo"
                                placeholder="plazo"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_term"
                                :error="getError('editFinancialObligation.plazo')"
                                v-model="obligationTerm">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label># de cuotas pendientes *</label>
                    <fg-input   tabindex="0"
                                type="number"
                                name="# de cuotas pendientes"
                                placeholder="# de cuotas pendientes"
                                autocomplete="off"
                                v-validate="modelValidations.obligation_pending"
                                :error="getError('editFinancialObligation.# de cuotas pendientes')"
                                v-model="obligationPendingQuota">
                    </fg-input>
                </div>
                <div v-if="parseInt(obligationPendingQuota) > parseInt(obligationTerm)" class="alert alert-danger mt-2">
                    <span>Las cuotas pendientes no pueden ser mayores al plazo</span>
                </div>
                <div class="form-group">
                    <label>% Cuotas *</label>
                    <fg-input   disabled
                                tabindex="0"
                                type="number"
                                name="porcentaje de cuotas"
                                placeholder="porcentaje de cuotas"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('porcentaje de cuotas')"
                                v-model="obligationPendingPercentComputed">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Periodicidad *</label>
                    <fg-input   name="periodicidad"
                                v-validate="modelValidations.periodicity"
                                :error="getError('editFinancialObligation.periodicidad')"
                                v-model="obligationPeriodicity">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationPeriodicity">
                            <el-option 
                                    class="select-warning"
                                    value="Mensual"
                                    label="Mensual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Bimensual"
                                    label="Bimensual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Trimestral"
                                    label="Trimestral">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Semestral"
                                    label="Semestral">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Anual"
                                    label="Anual">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Otra periodicidad"
                                    label="Otra periodicidad">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Mes inicio periodicidad *</label>
                    <el-date-picker
                        v-validate="'required'"
                        data-vv-name="mes inicio periodicidad"
                        name="mes inicio periodicidad"
                        :error="getError('editFinancialObligation.mes inicio periodicidad')"
                        v-model="obligationDate"
                        type="month"
                        placeholder="Seleccione mes inicio periodicidad">
                    </el-date-picker>
                    <span v-show="errors.has('editFinancialObligation.mes inicio periodicidad')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('editFinancialObligation.mes inicio periodicidad') }}
                    </span>
                </div>
                <div class="form-group">
                    <label>Destino del crédito *</label>
                    <fg-input   name="destino del crédito"
                                v-validate="modelValidations.obligationCreditDestiny"
                                :error="getError('editFinancialObligation.destino del crédito')"
                                v-model="obligationCreditDestiny">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="obligationCreditDestiny">
                            <el-option 
                                    class="select-warning"
                                    value="Capital de trabajo"
                                    label="Capital de trabajo">
                            </el-option>
                            <el-option 
                                    class="select-warning"
                                    value="Activo fijo"
                                    label="Activo fijo">
                            </el-option>
                            <el-option 
                                    v-show="obligationAccountType == 'TDC'"
                                    class="select-warning"
                                    value="Libre inversión"
                                    label="Libre inversión">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="obligationPeriodicity == 'Otra periodicidad'" class="form-group">
                    <div class="alert alert-info mt-2">
                        <span>Diligencia a continuación los meses para Otra periodicidad</span>
                    </div>
                    <div v-for="(month, index) in obligationMonths" :key="index" class="form-group">
                        <label>{{ month.name }}</label>
                        <vue-numeric  :max=999999999 tabindex="1" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.sales" :error="getError('valor')" separator="." class="form-control" v-model="month.value"></vue-numeric>
                    </div>
                </div>
                </form>
            <template slot="footer">
                <div class="left-side">
                    <p-button type="default" link @click="cancelEditObligation()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                    <p-button type="default" link @click="editObligationToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Hoja de trabajo</h4>
        </div>
       
        <!-- Vehicles -->
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Obligaciones con proveedores y financieras</h6>
            </div>
            <div class="card-body">
                <el-table v-if="actualObligations.length" :data="actualObligations"  ref="vehiclesTable"  @row-dblclick="showEditObligationMethod" highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <div>
                                <p><strong>Tipo de Obligación:</strong> {{ props.row.obligationType }}</p>
                                <p><strong>Entidad de la Obligación:</strong> {{ props.row.obligationEntity }}</p>
                                <p><strong>Rol:</strong> {{ props.row.obligationRole }}</p>
                                <p><strong>Tipo de Cuenta:</strong> {{ props.row.obligationAccountType }}</p>
                                <p><strong>Monto de Crédito:</strong> {{ setFormat(props.row.obligationAmountCredit) }}</p>
                                <p><strong>Saldo de Obligación:</strong> {{ setFormat(props.row.obligationResidue) }}</p>
                                <p><strong>Cuota:</strong> {{ setFormat(props.row.obligationQuota) }}</p>
                                <p><strong>Plazo:</strong> {{ props.row.obligationTerm }}</p>
                                <p><strong>Cuotas Pendiente:</strong> {{ props.row.obligationPendingQuota }}</p>
                                <p><strong>Porcentaje Pendiente:</strong> {{ props.row.obligationPendingPercent }}%</p>
                                <p><strong>Periodicidad:</strong> {{ props.row.obligationPeriodicity }}</p>
                                <p><strong>Mes inicio periodicidad:</strong> {{ formatDate(props.row.obligationDate) }}</p>
                                <p><strong>Destino del Crédito:</strong> {{ props.row.obligationCreditDestiny }}</p>

                                <!-- Mostrar los campos adicionales solo si el tipo de cuenta es 'TDC' -->
                                <div v-if="props.row.obligationAccountType === 'TDC'">
                                    <p><strong>Residuo Contingente:</strong> {{ setFormat(props.row.obligationContingentResidue) }}</p>
                                    <p><strong>Cuota Contingente:</strong> {{ setFormat(props.row.obligationContingentQuota) }}</p>
                                    <p><strong>Flujo de Cuota de Crédito:</strong> {{ setFormat(props.row.obligationQuotaCreditFlow) }}</p>
                                    <p><strong>Flujo de Saldo de Crédito:</strong> {{ setFormat(props.row.obligationResidueCreditFlow) }}</p>
                                </div>
                                <div v-if="props.row.obligationMonths && props.row.obligationMonths.length" class="form-group">
                                    <p><strong>Otra periodicidad:</strong></p>
                                    <div v-for="(month, index) in props.row.obligationMonths" :key="index">
                                        <p>{{ month.name }}: {{ setFormat(month.value) }}</p>
                                    </div>
                                </div>

                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Entidad" property="obligationEntity"></el-table-column>
                    <el-table-column label="Saldo">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.obligationResidue)}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                
                <div>
                    <p-button 
                        v-if="actualObligations.length < 10"
                        @click="addObligationMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar obligación
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="editObligationMethod(currentRow)"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar obligación
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="removeObligationMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar obligación
                    </p-button>
                </div>
                <div v-if="obligationTotalComputed != 0" class="alert alert-warning mt-2">
                    <span>Valor total obligaciones financieras : {{setFormat(obligationTotalComputed)}}</span>
                </div>
                <div v-if="obligationCAV != null && obligationCAV != 0" class="alert alert-info mt-2">
                    <span>Valor total obligaciones CAV : {{setFormat(obligationCAV)}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <div class="text-right">
            <p-button v-if="obligationTotalComputed != 0 || obligationCAV != 0" @click="saveObligations()" type="warning">Siguiente</p-button>
            <p-button @click="toMenu()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option, Table, TableColumn, DatePicker} from 'element-ui'
    import Expenses from 'src/util/Services/Expenses'
    import Travels from 'src/util/Services/Travels'
    import Taxes from 'src/util/Services/Taxes'
    import { update } from 'perfect-scrollbar'
    import { Validator } from "vee-validate";
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    Validator.extend('no_leading_zeros', {
        validate: (value) => {
            value = String(value).trim();

            // Permitir exactamente "0"
            if (value === '0') return true;

            // No permitir ceros a la izquierda (excepto "0" como único valor)
            if (/^0\d+/.test(value)) return false;

            // Rechazar números que son exactamente 0.0000 (o equivalentes)
            if (parseFloat(value) === 0) return false;

            // Debe ser un número válido (enteros o decimales positivos)
            return /^\d+(\.\d+)?$/.test(value);
        },
        getMessage: field => `${field} no debe tener ceros a la izquierda.`
    });
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal,
            [DatePicker.name]: DatePicker,
        },
        data() {
        return {
            cashFlowData: null,
            form: {
                average_selection: '',
            },
            tempObligationMonths: [],
            shouldReplaceObligation: false,
            manualQuotaOverride: '',
            contingentQuota: null,
            clientType: null,
            obligationType: '',
            obligationEntity: '',
            obligationRole: '',
            obligationAccountType: '',
            obligationAmountCredit: '',
            obligationResidue: '',
            obligationQuota: '',
            obligationContingentResidue: '',
            obligationContingentQuota: '',
            obligationQuotaCreditFlow: '',
            obligationResidueCreditFlow: '',
            obligationTerm: '',
            obligationPendingQuota: '',
            obligationPendingPercent: '',
            obligationPeriodicity: '',
            obligationDate: '',
            obligationMonths: null,
            obligationCreditDestiny: '',
            obligationCAV: null,
            obligationTotalBusiness: null,
            obligationResidueBusiness: null,
            obligationQuotaBusiness: null,
            obligationPendingPercentBusiness: null,
            obligationTotalFamiliar: null,
            obligationResidueFamiliar: null,
            obligationQuotaFamiliar: null,
            obligationPendingPercentFamiliar: null,
            alertFlag: true,
            periodicity: '',
            periodicityFlag: true,
            periodicityDaysFlag: true,
            periodicity_days: 0,
            vehicles : [],
            travels : [],
            expenses : [],
            taxes: [],
            obligations: [],
            actualObligations: [],
            actualVehicles: [],
            actualTravels: [],
            actualExpenses: [],
            actualTaxes: [],
            currentRow: null,
            currentTaxRow: null,
            currentTravelRow: null,
            currentExpenseRow: null,
            addExpense: false,
            editExpense: false,
            addObligation: false,
            editObligation: false,
            addTravel: false,
            editTravel: false,
            addTax: false,
            editTax: false,
            addObligationIndex: null,
            monthlyNumber: '',
            vehicleName: '',
            vehicleValue: '',
            vehicleLocked: false,
            expenseName: '',
            expenseValue: '',
            expenseLocked: false,
            travelName: '',
            travelValue: '',
            travelLocked: false,
            taxName: '',
            taxValue: '',
            taxPeriodicity: '',
            taxLocked: false,
            products: [
                
            ],
            costs: [],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
            modelValidations: {
                obligationType: {
                    required: true
                },
                obligationRole: {
                    required: true  
                },
                obligationAmountCredit: {
                    required: true
                },
                obligationResidue: {
                    required: true
                },
                obligationQuota: {
                    required: true
                },
                obligationQuotaCreditFlow: {
                    required: false
                },
                obligationQuotaCreditFlowRequired: {
                    required: true
                },
                sales: {
                    required: false
                },
                product_name: {
                    required: false,
                    max: 32,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/
                },
                item_costs: {
                    required: true,
                    min: 1,
                    max: 28
                },
                average_selection: {
                    required: false
                },
                entity_name: {
                    required: true,
                    max: 30,
                    regex: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ0-9 ]*$/
                },
                item_name: {
                    required: false,
                    max: 30
                },
                obligation_term: {
                    required: true,
                    max: 3,
                    no_leading_zeros: true
                },
                obligation_pending: {
                    required: true,
                    max: 3,
                    no_leading_zeros: true
                },
                periodicity: {
                    required: true
                },
                obligationAccountType: {
                    required: false
                },
                obligationCreditDestiny: {
                    required: true
                }
            },
        }
        },
        watch: {
            obligationContingentQuota(newVal, oldVal) {
                this.updateCreditFlow();
            },
            obligationQuota(newVal, oldVal) {
                this.updateCreditFlow();
            },
            obligationPeriodicity(newVal) {
                if (newVal === 'Otra periodicidad') {
                    const months = [];
                    const obligationPending = this.obligationPendingQuota;
                    const today = new Date();
                    let currentDate = new Date(today.getFullYear(), today.getMonth() + 1, 1); // Próximo mes

                    for (let i = 0; i < obligationPending; i++) {
                        const monthNumber = currentDate.getMonth() + 1; // Mes (de 1 a 12)
                        const year = currentDate.getFullYear(); // Año completo
                        const monthName = this.getMonthName(monthNumber); // Nombre del mes en español

                        months.push({
                        name: `${monthName}/${year.toString().slice(-2)}`,
                        value: 0
                        });

                        // Incrementa al siguiente mes
                        currentDate.setMonth(currentDate.getMonth() + 1);
                    }

                    this.obligationMonths = months;
                }
                else {
                    this.obligationMonths = null;
                }
                if (this.shouldReplaceObligation) {
                   this.updateObligationMonths();
                }
            },
            obligationPendingQuota(newVal){
                // this.obligationPeriodicity = '';
                if (this.obligationPeriodicity === 'Otra periodicidad') {
                    const months = [];
                    const obligationPending = newVal;
                    const today = new Date();
                    let currentDate = new Date(today.getFullYear(), today.getMonth() + 1, 1); // Próximo mes

                    for (let i = 0; i < obligationPending; i++) {
                        const monthNumber = currentDate.getMonth() + 1; // Mes (de 1 a 12)
                        const year = currentDate.getFullYear(); // Año completo
                        const monthName = this.getMonthName(monthNumber); // Nombre del mes en español

                        months.push({
                        name: `${monthName}/${year.toString().slice(-2)}`,
                        value: 0
                        });

                        // Incrementa al siguiente mes
                        currentDate.setMonth(currentDate.getMonth() + 1);
                    }

                    this.obligationMonths = months;
                }
                else {
                    this.obligationMonths = null;
                }
                if (this.shouldReplaceObligation) {
                   this.updateObligationMonths();
                }
            },
            obligationCreditDestiny(newVal){
                if(this.obligationType){
                    if(this.obligationType == 'OTRAS OBLIGA'){
                        if(newVal == 'Capital de trabajo'){
                            this.showNotificationError('Destino no válido');
                            this.obligationCreditDestiny = null;
                        }
                    }
                    else if(this.obligationType == 'PROVEEDOR'){
                        if(newVal == 'Activo fijo'){
                            this.showNotificationError('Destino no válido');
                            this.obligationCreditDestiny = null;
                        }
                    }
                }
            },
            obligationType(newVal){
                const currentAssessment = this.$store.state.assesments[this.$store.state.actualAssesment];
                if(this.$store.state.isCustomer){
                    if(currentAssessment.customer.actualStudy > 0){
                        if(newVal == "UNID FLIAR"){
                            this.showNotificationError('No puedes seleccionar este tipo de crédito');
                            this.obligationType = null;
                            return
                        }
                    }
                }
                else if(this.$store.state.isSpouse){
                    // if(currentAssessment.customerSpouse.actualStudy > 0){
                    //     if(newVal == "UNID FLIAR"){
                    //         this.showNotificationError('No puedes seleccionar este tipo de crédito');
                    //         this.obligationType = null;
                    //         return
                    //     }
                    // }
                    if(newVal == "UNID FLIAR"){
                        this.showNotificationError('No puedes seleccionar este tipo de crédito');
                        this.obligationType = null;
                        return
                    }
                }
                else if(this.$store.state.isGuarantor){
                    if(currentAssessment.guarantors[currentAssessment.actualGuarantors].actualStudy > 0){
                        if(newVal == "UNID FLIAR"){
                            this.showNotificationError('No puedes seleccionar este tipo de crédito');
                            this.obligationType = null;
                            return
                        }
                    }
                }
            },
            obligationAccountType(newVal) {
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            periodicity_days: function(newVal, oldVal) {
                if(newVal < 0) {
                    this.periodicity_days = 1;
                }
                else if(newVal > 7) {
                    this.periodicity_days = 7;
                }
                else if(newVal == '') {
                    this.periodicity_days = 0;
                }
                else {
                    this.periodicity_days = parseFloat(newVal)
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            periodicity: function(newVal, oldVal) {
                
                if (oldVal != '') {
                    this.periodicity_days = 0;
                }
            }
        },
        computed: {
            // obligationTotalComputed () {
            //     // Verifica si actualObligations es un array y no está vacío
            //     if (Array.isArray(this.actualObligations) && this.actualObligations.length > 0) {
            //     return this.actualObligations.reduce((total, obligation) => {
            //         // Suma el valor de obligationResidue si está definido, de lo contrario, suma 0
            //         return total + (parseFloat(obligation.obligationResidue) || 0);
            //     }, 0);
            //     }
            //     return 0; // Si no hay obligaciones, el total es 0
            // },
            obligationTitularComputed () {
                let totalGeneral = 0;
                // Verifica si actualObligations es un array y no está vacío
                if (Array.isArray(this.actualObligations) && this.actualObligations.length > 0) {
                this.actualObligations.forEach(obligation => {
                    const residue = parseFloat(obligation.obligationResidue) || 0;

                    if (obligation.obligationRole === "Titular" && obligation.obligationAccountType !== "CAV") {
                    totalGeneral += residue;
                    } 
                });
                }
                return totalGeneral;
            },
            obligationTotalComputed () {
                let totalGeneral = 0;
                let obligationCAV = 0;
                let obligationTotalBusiness = 0;
                let obligationTotalFamiliar = 0;
                let obligationResidueBusiness = 0;
                let obligationResidueFamiliar = 0;
                let obligationQuotaBusiness = 0;
                let obligationQuotaFamiliar = 0;
                let obligationPendingPercentBusiness = 0;
                let obligationPendingPercentFamiliar = 0;
                // Contadores para el promedio
                let countFamiliar = 0;
                let countBusiness = 0;

                // Verifica si actualObligations es un array y no está vacío
                if (Array.isArray(this.actualObligations) && this.actualObligations.length > 0) {
                this.actualObligations.forEach(obligation => {
                    const residue = parseFloat(obligation.obligationResidue) || 0;
                    const amount = parseFloat(obligation.obligationAmountCredit) || 0;
                    const quota = parseFloat(obligation.obligationQuota) || 0;
                    const pending = parseFloat(obligation.obligationPendingPercent) || 0;

                    if (obligation.obligationAccountType === "CAV") {
                    // Suma a obligationCAV si es de tipo "CAV"
                    obligationCAV += residue;
                    } else {
                    // Suma al total general si no es de tipo "CAV"
                    totalGeneral += residue;
                    }
                    if (obligation.obligationType === "UNID FLIAR") {
                    // Suma a obligationCAV si es de tipo "CAV"
                    obligationTotalFamiliar += amount;
                    obligationResidueFamiliar += residue;
                    obligationQuotaFamiliar += quota;
                    obligationPendingPercentFamiliar += pending;
                    countFamiliar++;
                    } else {
                    // Suma al total general si no es de tipo "CAV"
                    obligationTotalBusiness += amount;
                    obligationResidueBusiness += residue;
                    obligationQuotaBusiness += quota;
                    obligationPendingPercentBusiness += pending;
                    countBusiness++;
                    }
                });
                }
                // Calcula el promedio para pendingPercent
                // obligationPendingPercentFamiliar = countFamiliar > 0 ? obligationPendingPercentFamiliar / countFamiliar : 0;
                // obligationPendingPercentBusiness = countBusiness > 0 ? obligationPendingPercentBusiness / countBusiness : 0;
                obligationPendingPercentFamiliar = countFamiliar > 0 
                ? Number((obligationPendingPercentFamiliar / countFamiliar).toFixed(2)) 
                : 0;
                obligationPendingPercentBusiness = countBusiness > 0 
                ? Number((obligationPendingPercentBusiness / countBusiness).toFixed(2)) 
                : 0;

                // Asignamos el valor a una propiedad de la instancia (para poder usarlo en la vista)
                this.obligationCAV = obligationCAV;
                this.obligationTotalFamiliar = obligationTotalFamiliar;
                this.obligationResidueFamiliar = obligationResidueFamiliar;
                this.obligationQuotaFamiliar = obligationQuotaFamiliar;
                this.obligationPendingPercentFamiliar = obligationPendingPercentFamiliar;
                this.obligationTotalBusiness = obligationTotalBusiness;
                this.obligationResidueBusiness = obligationResidueBusiness;
                this.obligationQuotaBusiness = obligationQuotaBusiness;
                this.obligationPendingPercentBusiness = obligationPendingPercentBusiness;

                // Retornamos el total general (sin "CAV")
                return totalGeneral;
            },
            obligationPendingPercentComputed() {
                let term = this.obligationTerm || 0; // Asegura que no sea nulo
                let pendingQuota = this.obligationPendingQuota || 0; // Asegura que no sea nulo
                // Calcular el porcentaje de cuotas pendientes
                const percent = term > 0 ? Math.round((pendingQuota / term) * 100) : 0;

                // Almacenar el valor en this.obligationPendingPercent
                this.obligationPendingPercent = percent;

                return percent; // Retornar el valor calculado
            },
            obligationResidueCreditFlowComputed() {
                const contingentResidue = this.obligationContingentResidue || 0;
                const residue = this.obligationResidue || 0;

                // Calcular el valor máximo
                const minValue = Math.max(contingentResidue, residue);

                // Almacenar el valor en this.obligationResidueCreditFlow
                this.obligationResidueCreditFlow = minValue;

                // Retornar el valor calculado
                return minValue;
            },
                
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             obligationContingentResidueComputed() {
                const clientName = this.clientType.name;
                
                // Buscar el objeto con el mismo nombre
                const result = this.contingentQuota.find(item => item.data.name === clientName);
                if (result) {
                    // Parsear ambos valores a float y multiplicarlos
                    const amountCredit = this.obligationAmountCredit ? parseFloat(this.obligationAmountCredit) : 0;
                    const balance = parseFloat(result.data.balance);

                    // Realizar la multiplicación y eliminar los decimales
                    this.obligationContingentResidue = Math.floor(amountCredit * balance / 100);

                    return this.obligationContingentResidue;
                } else {
                    return 0;  // Si no se encuentra el objeto, devolver 0
                }
            },
            obligationContingentQuotaComputed() {
                const clientName = this.clientType.name;
                
                // Buscar el objeto con el mismo nombre
                const result = this.contingentQuota.find(item => item.data.name === clientName);

                if (result) {
                    // Parsear ambos valores a float y multiplicarlos
                    const amountCredit = this.obligationAmountCredit ? parseFloat(this.obligationAmountCredit) : 0;
                    const quota = parseFloat(result.data.quota);

                    // Realizar la multiplicación y eliminar los decimales
                    this.obligationContingentQuota = Math.floor(amountCredit * quota / 100);

                    return this.obligationContingentQuota;
                } else {
                    return 0;  // Si no se encuentra el objeto, devolver 0
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCostTotalComputed() {
                var total = this.productQuantity * this.productCostUnity;
                this.productCostTotal = total;
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthlyCostComputed() {
                var total = 0;
                if (this.monthlyNumber != '') {
                    var total = this.productQuantity * this.productCostUnity * this.monthlyNumber;
                    this.productMonthlyCost = total;
                }
                return total;
            },
            // allVehiclesMonthlyCostComputed() {
            //     var sum = 0;
            //     if (this.monthlyNumber != '') {
            //         for (let i=0;i<this.actualVehicles.length;i++) {
            //             sum = sum + (this.actualVehicles[i].value * parseFloat(this.monthlyNumber));
            //         }
            //         this.alertFlag = true;
            //     }
            //     else {
            //         for (let i=0;i<this.actualVehicles.length;i++) {
            //             sum = sum + (this.actualVehicles[i].value);
            //         }
            //         if (sum != 0) {
            //             this.alertFlag = false;
            //         }
            //     }
            //     return sum   
            // },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             allTravelsMonthlyCostComputed() {
                var sum = 0;
                var flag = 0;
                if (this.periodicity == 'Diaria') {
                    this.periodicityDaysFlag = true;
                    if(this.periodicity_days != 0) {
                        flag = parseInt(this.periodicity_days)* 4;
                    }
                    else {
                        this.periodicityDaysFlag = false;
                    }
                }
                else if (this.periodicity == 'Semanal') {
                    flag = 4;
                }
                else if (this.periodicity == 'Mensual') {
                    flag = 1;
                }
                this.periodicityFlag = true;
                for (let i=0;i<this.actualTravels.length;i++) {
                    if (this.actualTravels[i].locked) {
                        if (flag == 0 && this.actualTravels[i].value != 0) {
                                this.periodicityFlag = false;
                        }
                        sum = sum + ((this.actualTravels[i].value)* flag);
                    }
                }
                return sum   
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             allExpensesMonthlyCostComputed() {
                var sum = 0;
                var flag = 0;
                if (this.periodicity == 'Diaria') {
                    this.periodicityDaysFlag = true;
                    if(this.periodicity_days != 0) {
                        flag = parseInt(this.periodicity_days)* 4;
                    }
                    else {
                        this.periodicityDaysFlag = false;
                    }
                }
                else if (this.periodicity == 'Semanal') {
                    flag = 4;
                }
                else if (this.periodicity == 'Mensual') {
                    flag = 1;
                }
                this.periodicityFlag = true;
                for (let i=0;i<this.actualExpenses.length;i++) {
                    if (this.actualExpenses[i].locked) {
                        if (flag == 0 && this.actualExpenses[i].value != 0) {
                                this.periodicityFlag = false;
                        }
                        sum = sum + ((this.actualExpenses[i].value)* flag);
                    }
                }
                return sum   
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allVehiclesMonthlyCostComputed() {
                var sum = 0;
                var flag = 0;
                if (this.periodicity == 'Diaria') {
                    this.periodicityDaysFlag = true;
                    if(this.periodicity_days != 0) {
                        flag = parseInt(this.periodicity_days)* 4;
                    }
                    else {
                        this.periodicityDaysFlag = false;
                    }
                }
                else if (this.periodicity == 'Semanal') {
                    flag = 4;
                }
                else if (this.periodicity == 'Mensual') {
                    flag = 1;
                }
                this.periodicityFlag = true;
                for (let i=0;i<this.actualVehicles.length;i++) {
                    if (this.actualVehicles[i].locked) {
                        if (flag == 0 && this.actualVehicles[i].value != 0) {
                                this.periodicityFlag = false;
                        }
                        sum = sum + ((this.actualVehicles[i].value)* flag);
                    }
                }
                return sum   
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allTaxesMonthlyCostComputed() {
                var sum = 0;
                for (let i=0;i<this.actualTaxes.length;i++) {
                    if (this.actualTaxes[i].periodicity == 'Mensual') {
                        sum = sum + this.actualTaxes[i].value;
                    }
                    else {
                        sum = sum + (this.actualTaxes[i].value/ 12);
                    }
                    
                }
                return sum 
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allCostsComputed() {
                return this.allVehiclesMonthlyCostComputed + this.allTaxesMonthlyCostComputed
            }
        },
        methods: {
            calculateTotalizedFinancialObligations(updatedMonths, totalizedFinancialObligations) {
                console.log("📢 Calculando totalizados de obligaciones financieras...");

                // 1️⃣ **Resetear totalizados**
                totalizedFinancialObligations = totalizedFinancialObligations.map(() => 0); // Resetea cada obligación financiera
                let totalizedFinancialObligationsByMonth = 0; // 🔹 Nuevo total global de todas las obligaciones

                // 2️⃣ **Recorrer los meses y calcular totales**
                updatedMonths.forEach((month, monthIndex) => { // 🔹 Iteramos sobre cada mes en orden
                    
                    let totalForMonth = 0; // Inicializamos la suma de obligaciones en ese mes

                    month.financialObligations.forEach((obligation) => { // 🔹 Iteramos sobre cada obligación en ese mes
                        
                        let value = obligation.value || 0; // Si no hay valor, se usa 0

                        // **Suma por cada obligación en todos los meses**
                        totalizedFinancialObligations[obligation.index] += value; // 🔹 Se acumula la obligación por su índice

                        // **Acumulamos el total del mes**
                        totalForMonth += value; 
                    });

                    // 3️⃣ **Asignamos el total del mes y acumulamos en el total global**
                    month.totalFinancialObligations = totalForMonth; // 🔹 Guardamos la suma total en el mes
                    totalizedFinancialObligationsByMonth += totalForMonth; // 🔹 Sumamos al total global

                    console.log(`📌 Mes: ${month.name} | Total Obligaciones: ${month.totalFinancialObligations}`);
                });

                console.log("✅ Totalizados calculados correctamente.");
                console.log("📌 TotalizedFinancialObligations:", totalizedFinancialObligations);
                console.log("📌 TotalizedFinancialObligationsByMonth (Global):", totalizedFinancialObligationsByMonth);

                return { updatedMonths, totalizedFinancialObligations, totalizedFinancialObligationsByMonth };
            },
            generateYearlyCashFlowStructure(months) {
                console.log("📢 Generando estructura anual con bloques de hasta 12 meses...");

                let yearlyStructure = [];
                let totalMonths = months.length;
                let yearIndex = 1;

                // 1️⃣ Recorrer los meses y dividirlos en grupos de hasta 12
                for (let i = 0; i < totalMonths; i += 12) {
                    let yearBlock = months.slice(i, i + 12); // Tomar un grupo de hasta 12 meses

                    yearlyStructure.push({
                        name: `Año ${yearIndex}`,
                        months: yearBlock
                    });

                    yearIndex++;
                }

                console.log("✅ Estructura anual generada correctamente:", yearlyStructure);
                return yearlyStructure;
            },
            initializeFinancialObligationsAndTotalized(financialObligations, months) {
                console.log("📢 Inicializando financialObligations en cada mes...");

                // Crear una copia de los meses para evitar mutaciones
                let updatedMonths = JSON.parse(JSON.stringify(months));

                // Inicializar totalizedFinancialObligations como una lista ordenada
                let totalizedFinancialObligations = Array(financialObligations.length).fill(0);
                let totalizedFinancialObligationsByMonth = 0; // Totalizado por mes

                // Iterar sobre cada mes y crear la lista de financialObligations en orden
                updatedMonths.forEach(month => {
                    month.financialObligations = financialObligations.map((obligation, index) => ({
                        index, // Guardamos el índice para el orden correcto
                        obligationEntity: obligation.obligationEntity, // Nombre de la entidad financiera
                        value: 0 // Inicializar en 0
                    }));

                    console.log(`✅ ${month.name}: ${financialObligations.length} financialObligations inicializadas.`);
                });

                console.log("✅ Financial obligations inicializadas correctamente.");
                console.log("✅ totalizedFinancialObligations inicializado correctamente:", totalizedFinancialObligations);

                return { updatedMonths, totalizedFinancialObligations, totalizedFinancialObligationsByMonth };
            },
            assignFinancialObligationsToMonths(financialObligations, months) {
            console.log("📢 Asignando valores a financialObligations en cada mes...");
            console.log(financialObligations);
            
            let updatedMonths = JSON.parse(JSON.stringify(months)); // Copia profunda

            financialObligations.forEach((obligation, index) => {
                let quota = obligation.obligationQuota;
                let maxQuotas = parseInt(obligation.obligationPendingQuota);
                let periodicity = obligation.obligationPeriodicity;
                let startDate = new Date(obligation.obligationDate);

                console.log(`🛠️ Procesando obligación: ${obligation.obligationEntity} | Tipo: ${periodicity} | Cuota: ${quota} | Máximo de cuotas: ${maxQuotas}`);

                if (periodicity === "Otra periodicidad") {
                    console.log(`🔄 Aplicando "Otra periodicidad" para ${obligation.obligationEntity}`);
                    obligation.obligationMonths.forEach(monthData => {
                        let targetMonth = updatedMonths.find(m => m.name === monthData.name);
                        if (targetMonth) {
                            targetMonth.financialObligations[index].value += monthData.value;
                            console.log(`📌 ${monthData.value} asignado a ${monthData.name} para ${obligation.obligationEntity}`);
                        }
                    });
                    return;
                }

                // 1️⃣ Buscar el primer mes válido en cashFlowData.months
                let currentMonth = this.getFirstValidMonth(updatedMonths, startDate);
                if (!currentMonth) return;

                let quotaCount = 0; // Contador de cuotas asignadas

                // 2️⃣ Iterar sobre los meses respetando la periodicidad y el límite de cuotas
                while (currentMonth && quotaCount < maxQuotas) {
                    let targetMonth = updatedMonths.find(m => m.name === currentMonth.name);
                    if (!targetMonth) break;

                    // 3️⃣ Sumar la cuota a ese mes
                    targetMonth.financialObligations[index].value += quota;
                    quotaCount++;

                    console.log(`💰 ${quota} agregado a ${currentMonth.name} para ${obligation.obligationEntity}`);

                    // 4️⃣ Buscar el siguiente mes basado en la periodicidad
                    currentMonth = this.getNextMonth(currentMonth.name, periodicity, updatedMonths);
                }
            });

            console.log("✅ Asignación de financialObligations completada.");
            return updatedMonths;
        },

        /**
         * 📌 Encuentra el primer mes válido en la lista de cashFlowData.months basado en una fecha de inicio
         */
        getFirstValidMonth(updatedMonths, startDate) {
            return updatedMonths.find(m => {
                let [month, year] = m.name.split("/");
                let monthIndex = this.getMonthIndex(month);
                let fullYear = parseInt("20" + year);
                return new Date(fullYear, monthIndex - 1, 1) >= startDate;
            });
        },

        /**
         * 📌 Retorna el siguiente mes según la periodicidad
         */
        getNextMonth(currentMonth, periodicity, validMonths) {
            let [month, year] = currentMonth.split("/");
            let monthIndex = this.getMonthIndex(month);
            let fullYear = parseInt("20" + year);

            let monthsToAdd = {
                "Mensual": 1,
                "Bimensual": 2,
                "Trimestral": 3,
                "Semestral": 6,
                "Anual": 12
            }[periodicity] || 1; 

            monthIndex += monthsToAdd;
            if (monthIndex > 12) {
                monthIndex -= 12;
                fullYear += 1;
            }

            let nextMonthName = this.getMonthName(monthIndex);
            let nextMonth = `${nextMonthName}/${String(fullYear).slice(-2)}`;

            return validMonths.find(m => m.name === nextMonth) || null;
        },

        /**
         * 📌 Obtiene el índice de un mes a partir de su nombre
         */
        getMonthIndex(monthName) {
            const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
            return months.indexOf(monthName) + 1;
        },

        /**
         * 📌 Obtiene el nombre de un mes a partir de su índice
         */
        getMonthName(monthIndex) {
            const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
            return months[monthIndex - 1];
        },

            // assignFinancialObligationsToMonths(financialObligations, months) {
            //     console.log("📢 Asignando valores a financialObligations en cada mes...");

            //     let updatedMonths = JSON.parse(JSON.stringify(months)); // Copia profunda

            //     financialObligations.forEach((obligation, obligationIndex) => {
            //         let obligationQuota = parseInt(obligation.obligationQuota) || 0;
            //         let obligationPendingQuota = parseInt(obligation.obligationPendingQuota) || 0;
            //         let obligationPeriodicity = obligation.obligationPeriodicity;
            //         let obligationStartDate = new Date(obligation.obligationDate);

            //         console.log(`🛠️ Procesando obligación: ${obligation.obligationEntity} | Tipo: ${obligationPeriodicity} | Cuota: ${obligationQuota} | Máximo de cuotas: ${obligationPendingQuota}`);

            //         // Encontrar el primer mes válido en cashFlowData.months
            //         let validMonths = updatedMonths.map(m => m.name);
            //         let firstValidMonth = validMonths.find(monthName => {
            //             let [month, year] = monthName.split("/");
            //             let monthIndex = this.getMonthIndex(month);
            //             let fullYear = parseInt("20" + year);

            //             return new Date(fullYear, monthIndex - 1, 1) >= obligationStartDate;
            //         });

            //         if (!firstValidMonth) {
            //             console.warn(`⚠️ No se encontró un mes válido para la obligación ${obligation.obligationEntity}`);
            //             return;
            //         }

            //         console.log(`✅ Primer mes válido: ${firstValidMonth}`);

            //         // Asignar valores mes a mes respetando periodicidad y cuotas pendientes
            //         let quotaCount = 0;
            //         let currentMonth = firstValidMonth;

            //         while (currentMonth && quotaCount < obligationPendingQuota) {
            //             let monthEntry = updatedMonths.find(m => m.name === currentMonth);
            //             if (!monthEntry) break;

            //             // Asegurar que financialObligations exista en el mes
            //             if (!monthEntry.financialObligations) {
            //                 monthEntry.financialObligations = [];
            //             }

            //             // Asegurar que la entrada de la obligación en ese mes exista
            //             if (!monthEntry.financialObligations[obligationIndex]) {
            //                 monthEntry.financialObligations[obligationIndex] = { value: 0 };
            //             }

            //             // Sumar la cuota en el mes correspondiente
            //             monthEntry.financialObligations[obligationIndex].value += obligationQuota;

            //             console.log(`💰 ${obligationQuota} agregado a ${currentMonth} para ${obligation.obligationEntity}`);

            //             // Buscar el siguiente mes basado en la periodicidad
            //             currentMonth = this.getNextMonth(currentMonth, obligationPeriodicity, validMonths);
            //             quotaCount++;
            //         }
            //     });

            //     console.log("✅ Asignación de financialObligations completada.");
            //     return updatedMonths;
            // },

            // getNextMonth(currentMonth, periodicity, validMonths) {
            //     let [month, year] = currentMonth.split("/");
            //     let monthIndex = this.getMonthIndex(month);
            //     let fullYear = parseInt("20" + year);

            //     let monthsToAdd = {
            //         "Mensual": 1,
            //         "Bimensual": 2,
            //         "Trimestral": 3,
            //         "Semestral": 6,
            //         "Anual": 12
            //     }[periodicity] || 1;

            //     monthIndex += monthsToAdd;
            //     if (monthIndex > 12) {
            //         monthIndex -= 12;
            //         fullYear += 1;
            //     }

            //     let nextMonthName = this.getMonthName(monthIndex);
            //     let nextMonth = `${nextMonthName}/${String(fullYear).slice(-2)}`;

            //     return validMonths.includes(nextMonth) ? nextMonth : null;
            // },

            // getMonthIndex(monthName) {
            //     const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
            //     return months.indexOf(monthName) + 1;
            // },

            // getMonthName(monthIndex) {
            //     const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
            //     return months[monthIndex - 1];
            // },


            changeCreditFlow(value){
                this.manualQuotaOverride = this.obligationQuotaCreditFlow;
            },
            updateCreditFlow(){
                if (this.manualQuotaOverride !== '') {
                    return this.manualQuotaOverride;
                }
                // Si no, calcular el valor
                const contingentQuota = Number(this.obligationContingentQuota) || 0;
                const quota = Number(this.obligationQuota) || 0;
                const maxQuota = Math.max(contingentQuota, quota);
                this.obligationQuotaCreditFlow = maxQuota;
            },
            // Método que realiza el reemplazo después de que el watch se haya ejecutado
            updateObligationMonths() {
                // Reemplaza el valor solo si la bandera está activada
                if (this.shouldReplaceObligation) {
                this.$nextTick(() => {
                    this.obligationMonths = [...this.tempObligationMonths];
                });
                this.shouldReplaceObligation = false; // Desactiva la bandera
                }
            },
            getMonthName(monthNumber) {
                const months = [
                    'Enero',
                    'Febrero',
                    'Marzo',
                    'Abril',
                    'Mayo',
                    'Junio',
                    'Julio',
                    'Agosto',
                    'Septiembre',
                    'Octubre',
                    'Noviembre',
                    'Diciembre',
                ];
                return months[monthNumber - 1];
            },
            // generateObligationMonths(obligations, months) {
            //     // Iteramos sobre cada obligación (product es ahora una obligación)
            //     obligations.forEach((obligation) => {
            //         // Inicializamos la propiedad 'obligationMonths' para cada obligación
            //         obligati = [];

            //         // Recorremos los meses disponibles
            //         months.forEach((monthData) => {
            //             // Inicializamos un objeto para cada mes
            //             let obligationMonth = {
            //                 name: monthData.name,
            //                 total: 0, // Inicializamos 'total' en 0 por defecto
            //             };

            //             // Calculamos la fecha de inicio de la obligación
            //             const obligationStartDate = new Date(obligation.obligationDate); // Fecha de inicio
            //             const obligationStartMonth = obligationStartDate.getMonth() + 1; // Mes de inicio
            //             const obligationStartYear = obligationStartDate.getFullYear();  // Año de inicio

            //             // Verificamos si el mes actual es posterior o igual al mes de inicio de la obligación
            //             const isAfterStart =
            //                 monthData.year > obligationStartYear ||
            //                 (monthData.year === obligationStartYear && monthData.month >= obligationStartMonth);

            //             // Si el mes es posterior o igual, aplicamos la lógica de la periodicidad
            //             if (isAfterStart) {
            //                 // Determinamos el valor máximo entre obligationQuota y obligationQuotaCreditFlow
            //                 const totalValue = Math.max(
            //                     obligation.obligationQuota || 0, 
            //                     obligation.obligationQuotaCreditFlow || 0
            //                 );

            //                 // Aplicamos la lógica según la periodicidad de la obligación
            //                 switch (obligation.obligationPeriodicity) {
            //                     case 'Mensual':
            //                         obligationMonth.total = totalValue; // Asignamos el valor mensual fijo
            //                         break;
            //                     case 'Bimensual':
            //                         // Asignamos el valor cada dos meses
            //                         if ((monthData.month - obligationStartMonth) % 2 === 0) {
            //                             obligationMonth.total = totalValue;
            //                         }
            //                         break;
            //                     case 'Trimestral':
            //                         // Asignamos el valor cada tres meses
            //                         if ((monthData.month - obligationStartMonth) % 3 === 0) {
            //                             obligationMonth.total = totalValue;
            //                         }
            //                         break;
            //                     case 'Semestral':
            //                         // Asignamos el valor cada seis meses
            //                         if ((monthData.month - obligationStartMonth) % 6 === 0) {
            //                             obligationMonth.total = totalValue;
            //                         }
            //                         break;
            //                     case 'Anual':
            //                         // Asignamos el valor solo al mes de inicio
            //                         if (monthData.month === obligationStartMonth) {
            //                             obligationMonth.total = totalValue;
            //                         }
            //                         break;
            //                     default:
            //                         break;
            //                 }
            //             }

            //             // Si no hay asignación del total, aseguramos que sea 0
            //             if (obligationMonth.total === 0) {
            //                 obligationMonth.total = 0;
            //             }

            //             // Añadimos el mes con su total calculado a la propieda' de la obligación
            //             obligation.obligationMonthsData.push(obligationMonth);
            //         });
            //     });

            //     // Devolvemos el arreglo de obligaciones actualizado con sus obligationMonths calculados
            //     return obligations;
            // },
            generateObligationMonthsForProducts(products, months) {
                // Recorremos cada producto (obligación)
                products.forEach((product) => {
                    // Inicializamos la propiedad 'obligationMonthsData' para cada producto
                    product.obligationMonthsData = [];

                    // Recorremos cada mes de los meses disponibles
                    months.forEach((monthData) => {
                        // Inicializamos un objeto para cada mes
                        let obligationMonth = {
                            name: monthData.name,
                            total: 0, // Inicializamos 'total' en 0 por defecto
                        };

                        // Si la periodicidad es "Otra periodicidad"
                        if (product.obligationPeriodicity === "Otra periodicidad") {
                            // Buscamos el mes correspondiente en 'obligationMonths' y asignamos su valor
                            const matchedMonth = product.obligationMonths.find(
                                (oMonth) => oMonth.name === monthData.name
                            );

                            if (matchedMonth) {
                                obligationMonth.total = matchedMonth.value; // Asignamos el valor encontrado
                            } else {
                                obligationMonth.total = 0; // Si no hay coincidencia, lo dejamos en 0
                            }
                        } else {
                            // Si la periodicidad no es "Otra periodicidad", se calcula de acuerdo a la lógica anterior
                            const isAfterStart = new Date(product.obligationDate) >= new Date();

                            if (isAfterStart) {
                                // Si la periodicidad es mensual
                                if (product.obligationPeriodicity === "Mensual") {
                                    if (new Date(product.obligationDate).getMonth() <= monthData.month - 1) {
                                        obligationMonth.total = product.obligationQuota;
                                    }
                                }
                                // Si la periodicidad es bimensual
                                else if (product.obligationPeriodicity === "Bimensual") {
                                    if ((monthData.month - 1 - new Date(product.obligationDate).getMonth()) % 2 === 0) {
                                        obligationMonth.total = product.obligationQuota;
                                    }
                                }
                                // Si la periodicidad es trimestral
                                else if (product.obligationPeriodicity === "Trimestral") {
                                    if ((monthData.month - 1 - new Date(product.obligationDate).getMonth()) % 3 === 0) {
                                        obligationMonth.total = product.obligationQuota;
                                    }
                                }
                                // Si la periodicidad es semestral
                                else if (product.obligationPeriodicity === "Semestral") {
                                    if ((monthData.month - 1 - new Date(product.obligationDate).getMonth()) % 6 === 0) {
                                        obligationMonth.total = product.obligationQuota;
                                    }
                                }
                                // Si la periodicidad es anual
                                else if (product.obligationPeriodicity === "Anual") {
                                    if (monthData.month - 1 === new Date(product.obligationDate).getMonth()) {
                                        obligationMonth.total = product.obligationQuota;
                                    }
                                }
                                // Si la periodicidad es "Seleccionar mes" (una única vez en un mes específico)
                                else if (product.obligationPeriodicity === "Seleccionar mes") {
                                    const selectedMonthDate = new Date(product.obligationDate);
                                    if (
                                        selectedMonthDate.getFullYear() === monthData.year &&
                                        selectedMonthDate.getMonth() + 1 === monthData.month
                                    ) {
                                        obligationMonth.total = product.obligationQuota;
                                    }
                                }
                            }
                        }

                        // Añadimos el mes y su total a la propiedad 'obligationMonthsData' del producto
                        product.obligationMonthsData.push(obligationMonth);
                    });
                });

                // Retornamos los productos con sus obligationMonthsData calculados
                return products;
            },


            toMenu () {
                this.$router.push('/asessments/menu');
            },
            formatDate(date) {
                if (!date) return '';
                const formattedDate = new Date(date).toLocaleDateString('es-ES', {
                year: 'numeric',
                month: '2-digit'
                });
                return formattedDate;
            },
            resetObligationQuotaCreditFlow() {
                // Restablecer el valor manual para que use el cálculo automático
                this.manualQuotaOverride = '';
                this.updateCreditFlow();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            validateObligation() {
                // Validar que no haya campos vacíos en las propiedades que NO pueden ser nulos, vacíos o 0
                if (!this.obligationType ||
                    !this.obligationEntity ||
                    !this.obligationRole ||
                    !this.obligationAccountType ||
                    !this.obligationAmountCredit ||
                    !this.obligationResidue ||
                    !this.obligationQuota ||
                    !this.obligationTerm ||
                    !this.obligationPendingQuota ||
                    !this.obligationPendingPercent ||
                    !this.obligationPeriodicity ||
                    !this.obligationDate ||
                    !this.obligationCreditDestiny) {
                    this.showNotificationError('La obligación no tiene los datos completamente diligenciados')
                    return false;  // Detener la ejecución si hay error
                }

                // Si no hay errores de validación, limpiar el mensaje de error
                return true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showEditObligationMethod (currentRow) {
                // Asigna los valores de currentRow a los campos de la obligación
                this.obligationType = currentRow.obligationType;
                this.obligationEntity = currentRow.obligationEntity;
                this.obligationRole = currentRow.obligationRole;
                this.obligationAccountType = currentRow.obligationAccountType;
                this.obligationAmountCredit = currentRow.obligationAmountCredit;
                this.obligationResidue = currentRow.obligationResidue;
                this.obligationQuota = currentRow.obligationQuota;
                this.obligationContingentResidue = currentRow.obligationContingentResidue;
                this.obligationContingentQuota = currentRow.obligationContingentQuota;
                this.obligationQuotaCreditFlow = currentRow.obligationQuotaCreditFlow;
                this.obligationResidueCreditFlow = currentRow.obligationResidueCreditFlow;
                this.obligationTerm = currentRow.obligationTerm;
                this.obligationPendingQuota = currentRow.obligationPendingQuota;
                this.obligationPendingPercent = currentRow.obligationPendingPercent;
                this.obligationPeriodicity = currentRow.obligationPeriodicity;
                this.obligationDate = currentRow.obligationDate;
                this.obligationCreditDestiny = currentRow.obligationCreditDestiny;
                this.obligationMonths = currentRow.obligationMonths;
                this.manualQuotaOverride = currentRow.manualQuotaOverride;

                // Marca el estado de edición como verdadero para abrir el modal
                this.editObligation = true;




            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             showEditExpensesMethod (row) {
                this.expenseName= row.name;
                this.expenseValue= row.value;
                this.expenseLocked = row.locked;
                this.editObligation = true;
            },
             /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             showEditTravelsMethod (row) {
                this.travelName= row.name;
                this.travelValue= row.value;
                this.travelLocked = row.locked;
                this.editTravel = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showEditTaxesMethod (row) {
                this.taxName= row.name;
                this.taxValue= row.value;
                this.taxLocked = row.locked;
                this.taxPeriodicity = row.periodicity;
                this.editTax = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             handleTravelCurrentChange(currentRow, oldCurrentRow) {
                this.currentTravelRow = currentRow;
            },
             /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             handleExpenseCurrentChange(currentRow, oldCurrentRow) {
                this.currentExpenseRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleTaxCurrentChange(currentRow, oldCurrentRow) {
                this.currentTaxRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.itemName == '' || this.itemPercent == 0) {
                            this.showNotificationError('El campo nombre de ítem y porcentaje no pueden estar vacíos');
                        }
                        else {
                            this.products[this.addProductIndex].items.push({
                                itemName: this.itemName,
                                itemPurchasePrice: this.itemPurchasePrice,
                                itemSalePrice: this.itemSalePrice,
                                itemPercent: this.itemPercent
                            })
                            this.resetItem();
                            this.addProduct = false;
                            this.addProductIndex = null;
                            this.showNotificationSuccess('Ítem agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editObligationToList() {
                this.$validator.validateAll('editFinancialObligation').then(isValid => {
                if (isValid) {
                    if (!this.validateObligation()) {
                    return;  // Si la validación falla, no se ejecuta la edición
                    } else {
                    // Encuentra el índice de la obligación que estás editando en actualObligations
                    const obligationIndex = this.actualObligations.findIndex(obligation => 
                        obligation === this.currentRow // Asume que tienes una referencia a la obligación seleccionada
                    );
                    
                    if (obligationIndex !== -1) {
                        // Actualiza la obligación en actualObligations con los nuevos valores
                        this.actualObligations.splice(obligationIndex, 1, {
                        obligationType: this.obligationType,
                        obligationEntity: this.obligationEntity,
                        obligationRole: this.obligationRole,
                        obligationTC: this.obligationRole ? this.obligationRole.charAt(0) : '',
                        obligationAccountType: this.obligationAccountType,
                        obligationAmountCredit: this.obligationAmountCredit,
                        obligationResidue: this.obligationResidue,
                        obligationQuota: this.obligationQuota,
                        obligationContingentResidue: this.obligationContingentResidue,
                        obligationContingentQuota: this.obligationContingentQuota,
                        obligationQuotaCreditFlow: this.obligationQuotaCreditFlow,
                        obligationResidueCreditFlow: this.obligationResidueCreditFlow,
                        obligationTerm: this.obligationTerm,
                        obligationPendingQuota: this.obligationPendingQuota,
                        obligationPendingPercent: this.obligationPendingPercent,
                        obligationPeriodicity: this.obligationPeriodicity,
                        obligationDate: this.obligationDate,
                        obligationCreditDestiny: this.obligationCreditDestiny,
                        obligationMonths: this.obligationMonths,
                        manualQuotaOverride : this.manualQuotaOverride
                        });

                        // Reinicia los campos de la obligación y cierra el modal
                        this.resetObligation();
                        this.editObligation = false;
                        this.currentRow = null;
                        this.showNotificationSuccess('Obligación editada correctamente');
                    } else {
                        this.showNotificationError('Error al editar la obligación'); // Notificación en caso de error
                    }
                    }
                }
                else {
                    console.error('Error: Campos no diligenciados correctamente');
                    console.log('Errores de validación:', this.errors.items);
                    this.showNotificationError('Campos no diligenciados correctamente');
                    

                }
                });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editExpenseToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.expenseName == '') {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            var index = this.actualExpenses.indexOf(this.currentExpenseRow);
                            this.actualExpenses[index].name = this.expenseName;
                            this.actualExpenses[index].value = this.expenseValue;
                            this.resetObligation();
                            this.currentRow = null;
                            this.$refs.expensesTable.setCurrentRow();
                            this.editExpense = false;
                            this.showNotificationSuccess('Gasto editado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editTaxToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.taxName == '') {
                            this.showNotificationError('El campo nombre de impuesto no puede estar vacío');
                        }
                        else {
                            var index = this.actualTaxes.indexOf(this.currentTaxRow);
                            this.actualTaxes[index].name = this.taxName;
                            this.actualTaxes[index].value = this.taxValue;
                            this.actualTaxes[index].periodicity = this.taxPeriodicity;
                            this.resetTax();
                            this.currentTaxRow = null;
                            this.$refs.taxesTable.setCurrentRow();
                            this.editTax = false;
                            this.showNotificationSuccess('Impuesto editado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addObligationMethod (row) {
                // this.addProductIndex = row;
                this.resetObligation();
                this.addObligation = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addExpenseMethod (row) {
                // this.addProductIndex = row;
                this.resetExpense();
                this.addExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addTravelMethod (row) {
                // this.addProductIndex = row;
                this.resetTravel();
                this.addTravel = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addTaxMethod (row) {
                // this.addProductIndex = row;
                this.resetTax();
                this.addTax = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName = '';
                this.itemPurchasePrice = '';
                this.itemSalePrice = '';
                this.itemPercent = '';
                this.productName= '';
                this.productQuantity= '';
                this.productCostUnity= '';
                this.productCostTotal= '';
                this.productMonthlyCost= '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addObligationToList () {
                this.$validator.validateAll('addFinancialObligation').then(isValid => {
                    if(isValid){
                        if (!this.validateObligation()) {
                            return;  // Si la validación falla, no se ejecuta el guardado
                        }
                        else {
                            this.obligation = {
                                obligationType: this.obligationType,
                                obligationEntity: this.obligationEntity,
                                obligationRole: this.obligationRole,
                                obligationTC: this.obligationRole ? this.obligationRole.charAt(0) : '',
                                obligationAccountType: this.obligationAccountType,
                                obligationAmountCredit: this.obligationAmountCredit,
                                obligationResidue: this.obligationResidue,
                                obligationQuota: this.obligationQuota,
                                obligationContingentResidue: this.obligationContingentResidue,
                                obligationContingentQuota: this.obligationContingentQuota,
                                obligationQuotaCreditFlow: this.obligationQuotaCreditFlow,
                                obligationResidueCreditFlow: this.obligationResidueCreditFlow,
                                obligationTerm: this.obligationTerm,
                                obligationPendingQuota: this.obligationPendingQuota,
                                obligationPendingPercent: this.obligationPendingPercent,
                                obligationPeriodicity: this.obligationPeriodicity,
                                obligationDate: this.obligationDate,
                                obligationCreditDestiny: this.obligationCreditDestiny,
                                obligationMonths: this.obligationMonths,
                                manualQuotaOverride: this.manualQuotaOverride
                            };
                            
                            this.actualObligations.push({...this.obligation});
                            this.resetObligation();
                            this.addObligation = false;
                            this.showNotificationSuccess('Obligación agregada correctamente');
                        }
                    }
                    else {
                        this.showNotificationError('Campos no diligenciados correctamente');
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addExpenseToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.expenseName == '') {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            var id = this.actualExpenses.length + 1;
                            this.actualExpenses.push({
                                id: id,
                                name: this.expenseName,
                                value: this.expenseValue,
                                locked: false
                            })
                            this.resetExpense();
                            this.addExpense = false;
                            this.showNotificationSuccess('Gasto agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             addTravelToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.travelName == '') {
                            this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                        }
                        else {
                            var id = this.actualTravels.length + 1;
                            this.actualTravels.push({
                                id: id,
                                name: this.travelName,
                                value: this.travelValue,
                                locked: false
                            })
                            this.resetTravel();
                            this.addTravel = false;
                            this.showNotificationSuccess('Gasto agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addTaxToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.taxName == '') {
                            this.showNotificationError('El campo nombre de impuesto no puede estar vacío');
                        }
                        else {
                            var id = this.actualTaxes.length + 1;
                            this.actualTaxes.push({
                                id: id,
                                name: this.taxName,
                                periodicity: this.taxPeriodicity,
                                value: this.taxValue,
                                locked: false
                            })
                            this.resetTax();
                            this.addTax = false;
                            this.showNotificationSuccess('Impuesto agregado correctamente');
                        }
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetObligation () {
                this.obligationType = '';
                this.obligationEntity = '';
                this.obligationRole = '';
                this.obligationAccountType = '';
                this.obligationAmountCredit = '';
                this.obligationResidue = '';
                this.obligationQuota = '';
                this.obligationContingentResidue = '';
                this.obligationContingentQuota = '';
                this.obligationQuotaCreditFlow = '';
                this.obligationResidueCreditFlow = '';
                this.obligationTerm = '';
                this.obligationPendingQuota = '';
                this.obligationPendingPercent = '';
                this.obligationPeriodicity = '';
                this.obligationDate = '';
                this.obligationCreditDestiny = '';
                this.obligationMonths = null;
                this.manualQuotaOverride = '';
            },
             /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             resetExpense () {
                this.expenseName = '';
                this.expenseValue = '';   
                this.expenseLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             resetTravel () {
                this.travelName = '';
                this.travelValue = '';   
                this.travelLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetTax () {
                this.taxName = '';
                this.taxValue = '';   
                this.taxPeriodicity = 'Anual';   
                this.taxLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod () {
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editObligationMethod (currentRow) {
                // Asigna los valores de currentRow a los campos de la obligación
                this.obligationType = currentRow.obligationType;
                this.obligationEntity = currentRow.obligationEntity;
                this.obligationRole = currentRow.obligationRole;
                this.obligationTC = currentRow.obligationRole ? currentRow.obligationRole.charAt(0) : '',
                this.obligationAccountType = currentRow.obligationAccountType;
                this.obligationAmountCredit = currentRow.obligationAmountCredit;
                this.obligationResidue = currentRow.obligationResidue;
                this.obligationQuota = currentRow.obligationQuota;
                this.obligationContingentResidue = currentRow.obligationContingentResidue;
                this.obligationContingentQuota = currentRow.obligationContingentQuota;
                this.obligationQuotaCreditFlow = currentRow.obligationQuotaCreditFlow;
                this.obligationResidueCreditFlow = currentRow.obligationResidueCreditFlow;
                this.obligationTerm = currentRow.obligationTerm;
                this.obligationPendingQuota = currentRow.obligationPendingQuota;
                this.obligationPendingPercent = currentRow.obligationPendingPercent;
                this.obligationPeriodicity = currentRow.obligationPeriodicity;
                this.obligationDate = currentRow.obligationDate;
                this.obligationCreditDestiny = currentRow.obligationCreditDestiny;
                // this.obligationMonths = currentRow.obligationMonths;
                this.manualQuotaOverride = currentRow.manualQuotaOverride;
                // this.tempObligationMonths = [...currentRow.obligationMonths];
                this.tempObligationMonths = [...(currentRow.obligationMonths || [])];
                this.shouldReplaceObligation = true;
                
    
                // Marca el estado de edición como verdadero para abrir el modal
                this.editObligation = true;
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editExpenseMethod () {
                this.expenseName= this.currentExpenseRow.name;
                this.expenseValue= this.currentExpenseRow.value;
                this.expenseLocked = this.currentExpenseRow.locked;
                this.editExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             editTravelMethod () {
                this.travelName= this.currentTravelRow.name;
                this.travelValue= this.currentTravelRow.value;
                this.travelLocked = this.currentTravelRow.locked;
                this.editTravel = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editTaxMethod () {
                this.taxName= this.currentTaxRow.name;
                this.taxPeriodicity= this.currentTaxRow.periodicity;
                this.taxValue= this.currentTaxRow.value;
                this.taxLocked = this.currentTaxRow.locked;
                this.editTax = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeObligationMethod () {
                this.actualObligations.splice(this.actualObligations.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             removeExpenseMethod () {
                this.actualExpenses.splice(this.actualExpenses.indexOf(this.currentExpenseRow),1);
                this.currentExpenseRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             removeTravelMethod () {
                this.actualTravels.splice(this.actualTravels.indexOf(this.currentTravelRow),1);
                this.currentTravelRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeTaxMethod () {
                this.actualTaxes.splice(this.actualTaxes.indexOf(this.currentTaxRow),1);
                this.currentTaxRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddObligation () {
                this.addObligation = false;
                this.resetObligation();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelAddExpense () {
                this.addExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelAddTravel () {
                this.addTravel = false;
                this.resetTravel();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditObligation () {
                this.editObligation = false;
                this.resetObligation();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelEditExpense () {
                this.editExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             cancelEditTravel () {
                this.editTravel = false;
                this.resetTravel();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddTax () {
                this.addTax = false;
                this.resetTax();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditTax () {
                this.editTax = false;
                this.resetTax();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            saveObligations () {
                if (this.obligationTotalComputed != 0 || this.obligationCAV != 0) {
                    this.obligations.push({
                        obligations: this.actualObligations,
                        totalObligations: this.obligationTotalComputed,
                        totalTitular: this.obligationTitularComputed,
                        totalObligationsCAV: this.obligationCAV,
                        obligationTotalFamiliar: this.obligationTotalFamiliar,
                        obligationResidueFamiliar: this.obligationResidueFamiliar,
                        obligationQuotaFamiliar: this.obligationQuotaFamiliar,
                        obligationPendingPercentFamiliar: this.obligationPendingPercentFamiliar,
                        obligationTotalBusiness: this.obligationTotalBusiness,
                        obligationResidueBusiness: this.obligationResidueBusiness,
                        obligationQuotaBusiness: this.obligationQuotaBusiness,
                        obligationPendingPercentBusiness: this.obligationPendingPercentBusiness
                    })
                    // Verifica si alguna obligación no tiene "obligationTC"
                    const obligationsWithoutTC = this.obligations[0].obligations.filter(item => !('obligationTC' in item));

                    // Si encuentra alguna, crea un string con las entidades
                    if (obligationsWithoutTC.length > 0) {
                        const entities = obligationsWithoutTC.map(item => item.obligationEntity);
                        const entitiesString = entities.join(', '); // Convierte el array en un string separado por comas
                        swal({
                            title: 'Algo no está bien',
                            text: `Las siguientes obligaciones no tienen T/C: ${entitiesString}`,
                            type: 'warning',
                            showCancelButton: true,
                            showConfirmButton: false,
                            confirmButtonText: 'Si, continuar',
                            cancelButtonText: 'Corregir',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        });
                        return
                    }
                    let { updatedMonths, totalizedFinancialObligations, totalizedFinancialObligationsByMonth } = this.initializeFinancialObligationsAndTotalized(this.obligations[0].obligations, this.cashFlowData.months);
                    updatedMonths  = this.assignFinancialObligationsToMonths(this.obligations[0].obligations, updatedMonths);
                    let yearlyCashFlow = this.generateYearlyCashFlowStructure(updatedMonths);
                    ({ totalizedFinancialObligations, totalizedFinancialObligationsByMonth } = this.calculateTotalizedFinancialObligations(updatedMonths, totalizedFinancialObligations, totalizedFinancialObligationsByMonth));
                    const payload = {
                        obligations: this.obligations,
                        months: updatedMonths,
                        totalizedFinancialObligations: totalizedFinancialObligations,
                        totalizedFinancialObligationsByMonth: totalizedFinancialObligationsByMonth,
                        yearlyCashFlow: yearlyCashFlow
                    };
                    this.$store.dispatch('setAgroFinancialObligations', payload).then(()=>{
                        var vm = this;
                        swal({
                            title: '¿Deseas agregar información comercial a la unidad productiva Agro?',
                            text: 'Tienda/Comercio de mercancía/Actividades de servicios/Actividades de producción',
                            type: 'info',
                            showCancelButton: true,
                            confirmButtonText: 'Si, aceptar',
                            cancelButtonText: 'No, continuar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            cancelButtonClass: 'btn btn-danger btn-fill',
                            buttonsStyling: false
                        }).then(() => {
                            vm.$store.dispatch('newStudy', 'customer').then(()=>{
                                vm.$router.push('/asessments/new_asessment/customer/request_data');
                            });
                        }, function (dismiss) {
                            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
                            if (dismiss == 'cancel') {
                                vm.$router.push('/asessments/new_asessment/customer/others/additional_information');
                            }
                            else {
                                swal({
                                    title: 'Cancelado',
                                    text: 'El analista no ha continuado',
                                    type: 'error',
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    buttonsStyling: false
                                })
                            }
                        })
                    });
                    
                }
                else {
                    this.$router.push('/asessments/menu');
                }
                
            }
        },
        mounted () {
            this.contingentQuota =  this.$store.getters.getContingentQuotasTdcAgro;
            if (this.$store.state.isCustomer) {
                this.clientType = this.$store.getters.getClientTypes.find(client => client.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].agroData.cashFlow.clientType);
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.financialObligations && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.financialObligations.length != 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.financialObligations[0].obligations.length != 0) {
                    this.actualObligations = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.financialObligations[0].obligations;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowData;
            }
            else if(this.$store.state.isSpouse) {
                this.clientType = this.$store.getters.getClientTypes.find(client => client.id == this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].agroData.cashFlow.clientType);
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.financialObligations && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.financialObligations.length != 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.financialObligations[0].obligations.length != 0) {
                    this.actualObligations = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.financialObligations[0].obligations;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlowData;
            }
            else if(this.$store.state.isGuarantor) {
                this.clientType = this.$store.getters.getClientTypes.find(client => client.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[0].agroData.cashFlow.clientType);
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.financialObligations && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.financialObligations.length != 0 && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.financialObligations[0].obligations.length != 0) {
                    this.actualObligations = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.financialObligations[0].obligations;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlowData;
            }
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
